import { Box } from '@mui/material';
import { memo } from 'react';

import { HelpRequestMessage } from './HelpRequestMessage';

import { useCanContactSupport } from '../model/hooks/useCanContactSupport';
import { useSubmitHelpRequest } from '../model/hooks/useSubmitHelpRequest';
import { HelpRequestForm } from '../ui/HelpRequestForm';
import { InfoSection } from '../ui/InfoSection';

export const OrderHelpRequest = memo(() => {
    const { canContactSupport } = useCanContactSupport();
    const { messageData, isSubmitting, submitRequest } = useSubmitHelpRequest();

    // Hide help options if either: help request exists OR user can contact support
    const shouldShowHelpOptions = !messageData && !canContactSupport;

    return (
        <Box sx={{ flex: 1 }}>
            <InfoSection isHelpOptions={shouldShowHelpOptions} />

            {messageData && <HelpRequestMessage data={messageData} />}

            {!messageData && canContactSupport && (
                <HelpRequestForm
                    isSubmitting={isSubmitting}
                    onSubmit={submitRequest}
                />
            )}
        </Box>
    );
});
OrderHelpRequest.displayName = 'OrderHelpRequest';
